module.exports = __webpack_public_path__ + "36193bd79ebdc33a2336afa75d050e67.MP3";